import { b2x } from '@b2x/react/src';

import { AppContext, Brand } from './AppContext';
import { Footer } from './Footer';
import { Header } from './Header';
import { Icomoon } from './Icomoon';
import { ModalsAndOffcanvasses } from './ModalsAndOffcanvasses';
import { Error404Page } from './pages/Error404Page';
import { StoreLocatorPage } from './pages/StoreLocatorPage';
import { TemplatePage } from './pages/TemplatePage';

export const App = ({ brand, reverseProxy }: { brand: Brand; reverseProxy: boolean }) => {
  return (
    <AppContext brand={brand} reverseProxy={reverseProxy}>
      {({ getBrandVariant }) => (
        <>
          <b2x.App
            enableConfigurator={false}
            enableReactQueryDevtools={false}
            faviconIco={getBrandVariant({
              goldbet: 'https://repo.lottomaticagroup.com/intplatform/common/favicon/favicon.png',
              lottomatica: 'https://repo.lottomaticagroup.com/intplatform/common/favicon/favicon_ltmc.png',
              lottomaticaservizi:
                'https://repo.lottomaticagroup.com/intplatform/common/favicon/favicon_ltmc_servizi.png',
              planetwin365: 'https://repo.lottomaticagroup.com/intplatform/common/favicon/favicon_pwo.png',
            })}
            faviconPng={getBrandVariant({
              goldbet: 'https://repo.lottomaticagroup.com/intplatform/common/favicon/favicon.png',
              lottomatica: 'https://repo.lottomaticagroup.com/intplatform/common/favicon/favicon_ltmc.png',
              lottomaticaservizi:
                'https://repo.lottomaticagroup.com/intplatform/common/favicon/favicon_ltmc_servizi.png',
              planetwin365: 'https://repo.lottomaticagroup.com/intplatform/common/favicon/favicon_pwo.png',
            })}
            icomoonElement={<Icomoon />}
          >
            <ModalsAndOffcanvasses />
            <div className="d-flex flex-column flex-grow-1">
              <Header />
              <div className="flex-grow-1">
                <b2x.router.MainRouter
                  codeMappings={{
                    SITEMAP: { component: <StoreLocatorPage />, dynamicSegment: true },
                  }}
                  error404Page={<Error404Page />}
                  fixedMappings={{
                    template: <TemplatePage />,
                  }}
                />
              </div>
              <Footer />
            </div>
          </b2x.App>
        </>
      )}
    </AppContext>
  );
};
